<template>
  <div class="examination">
    <div class="title">
      <span :class="{'curspan':suoyin==index}" v-for="(mina,index) in mina_title" :key="index" @click="changeTab(index)">{{mina}}</span>
    </div>
    <div class="content">
      <div class="nav">
        <span class="spn1">年度</span>
        <span class="spn1">试卷名称</span>
        <span class="spn8">考试时间</span>
        <span class="spn7">状态</span>
        <span class="spn9">操作</span>
      </div>
      <ul v-for="item in kaoshidata" :key="item.id">
        <li class="l1">
          <span>2020年</span>
          <span :title="item.title">{{item.title}}</span>
          <span>{{item.start_time}}-{{item.end_time.split(' ')['1']}}</span>
          <span class="spn6 active">{{item.is_test=='0'?'-':item.is_test=='1'?'正在考试':'考试完成'}}</span>
          <span @click="gostady($event, item.kechengbao_id, item.is_pass, item.id, item.start_time)" v-if="item.is_test=='0'||item.is_test=='1'">{{item.is_test=='0'?'参加考试':'继续考试'}}</span>
           <span v-else>-</span> 
        </li>
      </ul>
      <!-- <div class="nodata" v-show="nodata"> -->
    </div>
    <div class="block" v-show="fenye" style="text-align:center;margin-top:20px;">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="pageNo" :page-size="11" layout="total,prev, pager, next, jumper"
        :total="count" :pager-count="7" v-show="count>11" background>
      </el-pagination>
    </div>
    <div class="tankuangs" @click="tankuang(id=1)" v-show="t_bool">

    </div>
    <div class="tankuang" v-show="t_bool">
      <span style="font-size: 22px;">考试说明:</span><br>
      <p style="text-indent:36px;text-align: left;font-size: 18px;">本次考试为全省统一网络统考，考试时间为<span>{{ kaoshidata[0]&&kaoshidata[0].start_time }}</span>。考试当天上午8：30后可开始登录考试系统，答题30分钟后可提前交卷，考试时间结束系统将自动提交试卷。每人仅有一次考试机会，请在考试期间保持良好的网络环境，不要在中途退出考试系统，以免影响考试成绩。如有问题请及时拨打客服电话。</p>
      <p><button @click="tankuang(id=2)">开始考试</button></p>
    </div>
  </div>
</template>

<script>
  import qs from 'qs'
  export default {
    name: "examination",
    data() {
      return {
        nodata: true,
        kaoshidata: [],
        year: '',
        suoyin: 0,
        uid: '',
        token: '',
        page: 1,
        currentPage: 1,
        
        fenye: true,
        page: 1,
        num: 11,
        count: 0,
        pageNo: 1,
        mina_title: ['考试列表',
          //'公需课'
        ],
        g_bol: false,
        z_bol: true,
        t_bool: false,
        shijuan_id: '',
        timestamp: "",
        inputDate: ""
      }
    },
    watch: {
      token: {
        handler: function(val) {
          if (val) {
            // this.getdata ()
          } else {
            this.removeInfo()
          }
        }
      },
      deep: true
    },
    // updated(){
    //   if(this.suoyin==0){
    //     this.getdata ();
    //     this.g_bol = false;
    //     this.z_bol = true;
    //   } else if(this.suoyin==1){
    //     this.getdata_g ();
    //     this.g_bol = true;
    //     this.z_bol = false;
    //   }
    // },
    mounted() {
      this.uid = localStorage.getItem('uid')
      this.token = localStorage.getItem('token')
      var date = new Date();
      this.year = date.getFullYear();
      if (this.token) {
        if (this.suoyin == 0) {
          this.getdata()
          this.g_bol = false;
          this.z_bol = true;
        } else if (this.suoyin == 1) {
          this.getdata_g()
          this.g_bol = true;
          this.z_bol = false;
        }

        if (sessionStorage.getItem('suoyin') == 0) {
          this.suoyin = sessionStorage.getItem('suoyin');
          this.kemuid = "";
          this.page = 1
        } else if (sessionStorage.getItem('suoyin') == 1) {
          this.suoyin = sessionStorage.getItem('suoyin');
          this.kemuid = 1;
          this.page = 1
        }

      } else {
        this.removeInfo()
      }  
      
    },
    methods: {
      tankuang(id) {
        if (id == 1) {
          this.t_bool = false
        } else(
          this.$router.push({
            path: "/kaoshi",
            query: {
              shijuan_id: this.shijuan_id
            }
          })
        )
      },
      changeTab: function(index) {
        this.suoyin = index;
        sessionStorage.setItem('suoyin', this.suoyin)
        if (index == 0) {
          this.kemuid = "";
          this.page = 1;
          this.g_bol = false;
          this.z_bol = true;
          this.getdata();
        } else if (index == 1) {
          this.kemuid = 1;
          this.page = 1;
          this.g_bol = true;
          this.z_bol = false;
          this.getdata_g();
        }
      },
      //分页
      handleCurrentChange(val) {
        this.page = val
        //console.log(`当前页: ${val}`);
        localStorage.setItem('pagenum', this.page)
        this.getdata()
      },
      removeInfo() {
        var that = this
        this.$message.error({
          message: "重新登录",
          duration: 1600
        });
        localStorage.removeItem("uid");
        localStorage.removeItem("token");
        localStorage.removeItem("sex");
        localStorage.removeItem("name");
        localStorage.removeItem("mobile");
        localStorage.removeItem("id_card");
        setTimeout(() => {
          that.$router.push({
            path: '/'
          });
        }, 1600);
      },
      //获取数据
      getdata() {
        var that = this
        this.$axios.post( '/kaoshi/get_shijuan_list',
          qs.stringify({
            year: this.year,
            uid: this.uid,
            token: this.token,
            page: this.page,
            num: this.num,
            type: '1'
          })
        ).then(res => {
          if (res.data.status == "ok") {
            that.kaoshidata = res.data.data
          } else if ((res.data.status == "error")) {
            that.$message.error({
              message: res.data.errormsg,
              duration: 1600
            });
          } else if ((res.data.status == "relogin")) {
            that.removeInfo();
          }
        });
      },
      //去学习
      gostady(e, num, type, shijuanid, time) {
       let t = time.replace(/-/g,"/")
        if (new Date().getTime() > Date.parse(t) ) {
          this.shijuan_id = shijuanid
          var that = this
          if (e.target.innerHTML == "继续学习") {
            if (type == 0) {
              this.$router.push({
                path: '/personalpackage',
                query: {
                  codeid: !!num&&num
                }
              })
            } else {
              that.$router.push({
                name: 'personalpackage',
                params: {
                  courseId: !!num&&num
                }
              })
            }

          }else if(e.target.innerHTML == "参加考试"){
            this.t_bool = true
          }else if(e.target.innerHTML == "继续考试"){
            this.t_bool = true
          }
        }else{
          this.$alert(' ', '考试暂未开始，请09:00后点击参加考试', {
                confirmButtonText: '确定',
                showClose:false,
                center: true,
                callback: () => {}
              })
        }
      },
      //切换分页
      current_change(currentPage) {
        this.currentPage = currentPage
      }
    }
  };
</script>

<style lang="less" scoped>
  .examination {
    width: 948px;
    background-color: #fff;
    box-sizing: border-box;

    // .title {
    //   width: 100%;
    //   height: 50px;
    //   line-height: 50px;
    //   border-bottom: 2px solid #f4f4f4;
    //   margin-bottom: 20px;
    //   box-sizing: border-box;
    //   h3 {
    //     color: #AD0008;
    //     span {
    //       padding-bottom: 11px;
    //       border-bottom: 2px solid #AD0008;
    //       box-sizing: border-box;
    //       cursor: default;
    //     }
    //   }
    // }

    .content {
      width: 100%;
      height: 642px;
      padding: 20px;

      .nav {
        height: 35px;
        line-height: 35px;
        background-color: #e1f1ff;
        color: #1a1a1c;
        font-size: 0;

        span {
          font-size: 14px;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: default;
        }

        span:nth-child(1) {
          width: 15%;
          text-align: center;
        }

        span:nth-child(2) {
          width: 15%;
          text-align: center;
        }

        span:nth-child(3) {
          width: 40%;
          text-align: center;
        }

        span:nth-child(4) {
          width: 15%;
          text-align: center;
        }

        span:nth-child(5) {
          width: 15%;
          text-align: center;
        }
      }

      ul {
        margin-top: 5px;
        width: 100%;
        box-sizing: border-box;
        height: 40px;
        line-height: 40px;

        li {
          width: 100%;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          color: #868686;
          cursor: pointer;

          span {
            display: inline-block;
            overflow: hidden;
          }

          span:nth-child(1) {
            width: 15%;
            text-align: center;
          }

          span:nth-child(2) {
            width: 14%;
            text-align: center;
            line-height: 40px;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          span:nth-child(3) {
            width: 38%;
            text-align: center;
          }

          span:nth-child(4) {
            width: 15%;
            text-align: center;
          }

          span:nth-child(5) {
            width: 15%;
            text-align: center;
          }
        }
      }

      .nodata {
        width: 212px;
        height: 240px;
        margin: 80px auto;
        background-image: url('../assets/nodata.png');
      }

    }



  }

  .title {
    width: 100%;
    height: 55px;
    // margin-bottom: 20px;
    font-size: 18px;
    padding-left: 35px;
    line-height: 55px;
    color: #0c69f5;
    box-sizing: border-box;
    border-bottom: 2px solid #eee;

    span {
      margin-right: 20px;
      cursor: pointer;
      color: #b9b9b9;
    }

    .curspan {
      border-bottom: 2px solid #AD0008;
      padding-bottom: 13px;
      color: #AD0008;
    }
  }

  .tankuangs {
    position: fixed;
    height: 100%;
    width: 100%;
    background: #000;
    left: 0;
    top: 0;
    opacity: 0.8;
  }

  .tankuang {
    position: fixed;
    background: #fff;
    color: #000;
    height: 350px;
    width: 400px;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: 300px auto;
    font-size: 18px;
    line-height: 30px;
    padding: 20px;

    p {
      text-align: right;

      button {
        background: #AD0008;
        color: #fff;
        padding: 10px 15px;
        border-radius: 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/examination.vue